import { useHasMounted } from "@whitespace/gatsby-hooks/src";
import {
  Alert,
  ErrorMessage,
  Loading,
  Invoices as InvoicesComponent,
} from "@whitespace/gatsby-theme-smorgasbord/src/components";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";

import useEdp from "../hooks/useEdp";
import transformInvoice from "../utils/transformInvoice.js";

import * as defaultStyles from "./Invoices.module.css";

Invoices.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
};

function InvoicesContent() {
  const { t } = useTranslation();
  const { error, data: { data: invoices = [] } = {} } = useEdp(
    "/invoices",
    { suspense: true },
    [],
  );

  if (error) {
    return <ErrorMessage error={error.message} />;
  }

  if (!invoices.length) {
    return <Alert msg={t("noInvoices")} />;
  }

  const transformedInvoices = invoices.map(transformInvoice);
  return <InvoicesComponent invoices={transformedInvoices} />;
}

export default function Invoices({
  styles = defaultStyles,
  className,
  ...restProps
}) {
  const hasMounted = useHasMounted();
  return (
    <div className={clsx(styles.component, className)} {...restProps}>
      {hasMounted && (
        <Suspense fallback={<Loading />}>
          <InvoicesContent />
        </Suspense>
      )}
    </div>
  );
}
